import  * as api from  '@/api/kzActivity/mutualEvaluate'
import * as TYPES from './type';

export default {
  // 课中活动评论
  async getMutualEvaluateList({ commit, state }, { paramets, cb }) {
    const result = await api.reqMutualEvaluateList(paramets)
    commit(TYPES.MUTUALEVALUATE_LIST, { result })
    cb && cb()
  },
  async getMutualEvaluateStuById({ commit, state }, { paramets, cb }) {
    const result = await api.reqMutualEvaluateStuById(paramets)
    commit(TYPES.MUTUALEVALUATE_INFO, { result, type: 'stu' })
    cb && cb()
  },
  async getMutualEvaluateDetail({ commit, state }, { paramets, cb }) {
    const result = await api.reqMutualEvaluateDetail(paramets)
    commit(TYPES.MUTUALEVALUATE_INFO, { result, type: 'detail' })
    cb && cb()
  },
  async delMutualEvaluateDelById({ commit, state }, { paramets, cb }) {
    const result = await api.reqMutualEvaluateDelById(paramets)
    commit(TYPES.MUTUALEVALUATE_INFO, { result, type: 'del' })
    cb && cb()
  },

  
  async postStuRecord({ commit, state }, { paramets, cb, cbParamets = {} }) {
    const result = await api.reqStuRecordAdd(paramets)
    commit(TYPES.MUTUALEVALUATE_INFO, { result, type: 'detail' })
    cb && cb(...cbParamets)
  },
  async getJxTypeById({ commit, state }, { paramets, cb, cbParamets = {} }) {
    const result = await api.reqJxTypeById(paramets)
    commit(TYPES.MUTUALEVALUATE_INFO, { result, type: 'stuOrGroup' })
    cb && cb(...cbParamets)
  },

  //过程性评价 list
 async getScoreStuRecordList({ commit, state }, { paramets, cb }) {
  const result = await api.reqScoreStuRecordList(paramets)
  commit(TYPES.SCORESTURECORD_LIST, { result })
  cb && cb()
},
async getShowStuOrGroupById({ commit, state }, { paramets, cb }) {
  const result = await api.reqShowStuOrGroupById(paramets)
  commit(TYPES.SCORESTURECORD_INFO, { result, type: 'stu' })
  cb && cb()
},
//删除
async delStuOrGroupByDate({ commit, state }, { paramets, cb }) {
  const result = await api.reqDelStuOrGroupByDate(paramets)
  commit(TYPES.SCORESTURECORD_INFO, { result, type: 'detail' })
  cb && cb()
},
//详情删除
async delStuOrGroupById({ commit, state }, { paramets, cb }) {
  const result = await api.reqDelStuOrGroupById(paramets)
  commit(TYPES.SCORESTURECORD_INFO, { result, type: 'detail' })
  cb && cb()
},

async getShowDetailsById({ commit, state }, { paramets, cb }) {
  const result = await api.reqShowStuOrGroupDetailsById(paramets)
  commit(TYPES.SCORESTURECORD_INFO, { result, type: 'detail' })
  cb && cb()
},

async getScoreStuRecord({ commit, state }, { paramets, cb }) {
  const result = await api.reqScore(paramets)
  commit(TYPES.MUTUALEVALUATE_INFO, { result, type: 'detail' })
  cb && cb()
},

}


// WEBPACK FOOTER //
// ./src/store/kzActivity/mutualEvaluate/actions.js